module.exports = __webpack_public_path__ + "static/media/fotogalereya7.b0006f24.jpg";